import { useState } from 'react';

const useAction = <T extends Array<any>, U>(
    handler: (...args: T) => Promise<U>,
): [(...args: T) => Promise<U>, boolean, boolean, boolean, Error | null] => {
    const [running, setRunning] = useState(false);
    const [finished, setFinished] = useState(false);
    const [justFinished, setJustFinished] = useState(false);
    const [error, setError] = useState<Error | null>(null);

    const wrapped = async (...args: T) => {
        setRunning(true);
        setFinished(false);
        setJustFinished(false);
        setError(null);

        try {
            const result = await handler(...args);

            setFinished(true);
            setJustFinished(true);

            setTimeout(() => {
                setJustFinished(false);
            }, 5000);

            return result;
        } catch (caught) {
            setError(caught instanceof Error ? caught : new Error('Something went wrong. Please try again.'));

            throw caught;
        } finally {
            setRunning(false);
        }
    };

    return [wrapped, running, finished, justFinished, error];
};

export { useAction };
